import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
// Bootstrap
import BootstrapVue from 'bootstrap-vue'
// Styling
import './assets/scss/oldevuuren.scss'
// Packages
import Vuelidate from 'vuelidate'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'
import vSelect from 'vue-select'
// Configurations, components, filters
import './fontawesome.js'
import './global-components.js'
import './global-filters.js'

// Vuelidate
Vue.use(Vuelidate)
// Bootstrap
Vue.use(BootstrapVue)
// lazyload
Vue.use(VueLazyload, {
  error: '/images/noimage.png'
})
// Select2
Vue.component('v-select', vSelect)

// Axios
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL
axios.defaults.headers.get['Accepts'] = 'application/json'
// Add authorization token if we have it
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

// Show user that we're not in production yet
Vue.config.productionTip = false

// Check if auth token is present and has expired
const expirationDate = localStorage.getItem('expirationDate')
if (expirationDate) {
  const now = Math.round((new Date()).getTime() / 1000)
  if (now >= expirationDate) {
    // If the date has passed the expirationDate, remove all localstorage items
    localStorage.clear()
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
